<template>
 <div @click="onClick">
      <div class="inline field">
        <label>Transaction Id: </label>
        <span>{{rowData.transaction_id}}</span>
      </div>
      <div class="inline field">
        <label>Invoice#: </label>
        <span>{{rowData.invoice_number}}</span>
      </div>
      <div class="inline field">
        <label>Vendor Name: </label>
        <span>{{rowData.vendor_name}}</span>
      </div>
      <div class="inline field">
        <label>Buyer Name: </label>
        <span>{{rowData.buyer_name}}</span>
      </div>
      <div class="inline field">
        <label>City: </label>
        <span>{{rowData.city}}</span>
      </div>
</div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onClick (event) {
            console.log('invoice-detail-row: on-click', event.target)
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/components/manage-documents/InvoiceDetailRow.vue